import GraphQL from "../../api/graphql";
import { make } from "vuex-pathify";

const state = {
    model: {
        id: "",
        name: "",
        group: "",
        groupAlias: ""
    }
};

const DEFAULT_MODEL = {
    id: "",
    name: "",
    group: "",
    groupAlias: ""
};

const mutations = make.mutations(state);

const actions = {
    async fetch({ dispatch, rootState }) {
        const client = new GraphQL({
            headers: {
                Authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        try {
            const response = await client.query({
                query: `{
                    me {
                        id
                        email
                        name
                        group {
                            alias
                            name
                        }
                    }
                }`,
                variables: {}
            });

            const user = {
                id: response.data.me.id,
                name: response.data.me.name,
                email: response.data.me.email,
                group: response.data.me.group.name,
                groupAlias: response.data.me.group.alias
            };

            this.set("user/model", user);
            await dispatch("menu/fetch", {}, { root: true });
        } catch (e) {
            console.error(e);
        }
    },
    reset() {
        this.set("user/model", DEFAULT_MODEL);
    }
};

export default { state, mutations, actions };
